<template>
	<div class="ms-cell-editor">
		<div
			v-show="!isSelected || readOnly"
			class="flex-center"
			:class="{ 'edit-disabled': readOnly, 'ms-editor-text': editable }"
		>
			<div class="editor-display">
				<span>{{
					dataRow[initField]
						| formatData({ formatType: col.formatType, enumName: col.enumName })
				}}</span>
			</div>
			<div
				class="icon-input float-right"
				v-tooltip="{
					content: cellErrorProvider.message,
					classes: 'error',
					placement: col.tooltipPlacement,
				}"
				v-if="cellErrorProvider.isValid"
			>
				<div class="mi mi-20 mi-icon-error mr-2"></div>
			</div>
		</div>
		<div
			class="ms-editor w-full h-full"
			ref="editor"
			v-show="isSelected && !readOnly"
		></div>
	</div>
</template>
<script>
import msCellInput from './msCellInput';
import msCombobox from '@/components/mscombobox/msCombobox.vue';
export default {
	name: 'msCellCombobox',
	extends: msCellInput,
	created() {
		const me = this;
		me.initField = me.col.initField ? me.col.initField : me.getDisplayField;
		me.col.initField = me.initField;
		if (me.col.getDataFromField) {
			let watchName = 'dataRow.' + me.col.getDataFromField;
			me.$watch(watchName, function (newVal, oldVal) {
				if (me.col.__editor) {
					me.col.__editor.data = newVal;
					if (typeof me.col.__editor.setInternalText === 'function') {
						me.col.__editor.setInternalText(me.dataRow[me.initField]);
					}
				}
			});
		}
	},
	data() {
		return {
			initField: null,
		};
	},
	computed: {
		getDisplayField() {
			const me = this;
			let editorProperty = me.getEditorProperty();
			if (editorProperty) {
				let props = editorProperty.propsData;
				return props.displayField;
			}
			return null;
		},
	},
	methods: {
		getEditorControl() {
			return msCombobox;
		},
		customEditProperty(editorProperty) {
			const me = this;
			if (editorProperty) {
				let props = editorProperty.propsData;
				if (me.col.getDataFromField) {
					props.data = me.dataRow[me.col.getDataFromField];
				}
			}
		},
		//Hàm xử lý trước khi edit reset lại các giá trị trong editor cũ
		//Created by LTDAT(17.06.2020)
		beforeEdit(editor) {
			const me = this;
			let dataRow = me.dataRow,
				col = me.col;
			let editorProperty = me.getEditorProperty(),
				props = editorProperty.propsData;
			if (editor) {
				// if(typeof editor.reset === 'function')
				// {
				//     editor.reset();
				// }
				if (typeof editor.setValue === 'function') {
					editor.setValue(me.dataRow[col.dataField]);
				}
				if (typeof editor.setInternalText === 'function') {
					editor.setInternalText(me.dataRow[me.initField]);
				}
				if (col.getDataFromField) {
					editor.data = dataRow[col.getDataFromField];
				}
				if (editor.applyValidate && typeof editor.applyValidate == 'function') {
					me.$nextTick(() => {
						editor.applyValidate(me.cellErrorProvider.message);
					});
				}
			}
			me.$emit('rowSelected', me.dataRow);
		},
		//Hàm custom thêm sự kiện cho control
		//Created by LTDAT(18.06.2020)
		addCustomHandler(editor) {
			const me = this;
			editor.$on('selected', me.directEventSelected);
			editor.$on('loadData', me.loadData);
		},
		loadData(payload) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				...payload,
			};
			me.$emit('loadDataCombo', metaData);
		},
		directEventSelected() {
			let me = this,
				col = me.col,
				editor = me.col.__editor;
			if (editor) {
				editor.$cell.selectedHandler(...arguments);
			}
		},
		selectedHandler(data) {
			const me = this;
			let col = me.col;
			if (data.newData) {
				me.$set(me.dataRow, me.initField, data.newData[me.getDisplayField]);
			} else {
				me.$set(me.dataRow, me.initField, null);
			}
			let metaData = {
				dataRow: me.dataRow,
				column: col,
				...data,
			};
			if (
				data &&
				data.hasOwnProperty('userAction') &&
				data.userAction === false
			) {
			} else {
				me.$emit('selected', metaData);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.editor-display {
	padding: 6px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 50px;
	overflow: hidden;
}
</style>